import { PC_PAL_PRODUCT_TYPE } from '@/pages/income/config';

export const config = {
  1: {
    title: 'x86专业版',
    component: 'X86',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/1f8d/1ea8',
    bindUrl: 'https://help.yfanqie.com/c165/2387#header-3',
    joinName: 'x86定向业务招募咨询群',
    joinImg: 'x86',
  },
  3: {
    title: '玩客云现金版',
    component: 'OnecloudCash',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/8076',
    joinName: '网心云赚钱宝交流群',
    joinImg: 'wkyCash',
  },
  5: {
    title: '小爱盒子',
    component: 'XiaoAiBox',
    detailUrl: 'https://help.yfanqie.com/caa9/0ae7/51b3',
    detailBtn: '查看教程',
  },
  7: {
    title: '三方盒子',
    component: 'SFBox',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/bd32',
    joinName: '网心云三方硬件交流群',
    joinImg: 'sf',
  },
  1000: {
    title: '赚钱宝3代Pro',
    component: 'OnecloudPro3',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/e099',
    joinName: '网心云赚钱宝交流群',
    joinImg: 'zqb',
  },
  1003: {
    title: '赚钱宝3代',
    component: 'Zqb3',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/wky',
    joinName: '网心云赚钱宝交流群',
    joinImg: 'zqb',
  },
  1004: {
    title: '赚钱宝3代租赁版',
    component: 'Zqb3Rent',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/wky',
  },
  1006: {
    title: '纳思小星',
    component: 'Nas',
    joinName: '网心云纳思小星交流群',
    joinImg: 'nas',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/nasxx',
  },
  1007: {
    title: '福利码-玩客云/赚3',
    component: 'WelfareCard',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/caa9/flm',
    joinName: '网心云赚钱宝交流群',
    joinImg: 'flm',
  },
  1008: {
    title: '福利码-三方盒子',
    // type: TYPE_CODE,
    component: 'SFWelfareCode',
    detailBtn: '马上入手',
    detailUrl: '/mall/xcode/16?by=h5',
    // joinName: '网心云赚钱宝交流群',
    // joinImg: 'flm',
  },
  oes: {
    title: 'OES',
    component: 'OES',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/OES/04b7',
    joinName: '网心云OES交流群',
    joinImg: 'oes',
  },
  oec: {
    title: 'OEC',
    component: 'OEC',
    detailBtn: '查看教程',
    detailUrl: 'https://help.yfanqie.com/OEC1/8127',
    joinName: '网心云OEC交流群',
    joinImg: 'oec',
  },
  phone: {
    title: '手机宝',
    component: 'Phone',
    detailBtn: '产品官网',
    detailUrl: 'https://www.yfanqie.com/products/phone-pal',
    joinName: '网心云手机宝交流群',
    joinImg: 'phone',
  },
  padPal: {
    title: '手机宝HD',
    component: 'PadPal',
    detailBtn: '产品官网',
    detailUrl: 'https://www.yfanqie.com/products/phone-pal',
    joinName: '网心云手机宝HD交流群',
    joinImg: 'padPal',
  },
  [PC_PAL_PRODUCT_TYPE]: {
    title: '电脑宝',
    component: 'PCPal',
    detailBtn: '产品官网',
    detailUrl: 'https://www.yfanqie.com/products/zqb-lite',
    joinName: '网心云电脑宝交流群',
    joinImg: PC_PAL_PRODUCT_TYPE,
  },
};

export const X86_DOWNLOAD_INFO = [
  {
    title: 'Hyper-V安装教程 >',
    desc: 'win10首选',
    link: 'https://w.1yb.co/V987xaE',
  },
  {
    title: 'ISO安装教程 >',
    desc: '支持纯物理机/虚拟机',
    link: 'https://w.1yb.co/VOvylqE',
  },
  {
    title: 'KVM安装教程 >',
    desc: 'linux系统',
    link: 'https://help.yfanqie.com/1f8d/35e9/279e',
  },
  {
    title: 'VMware安装教程 >',
    desc: 'windows系统都支持',
    link: 'https://w.1yb.co/E1jxDXV',
  },
  {
    title: '群晖安装教程 >',
    desc: '支持群晖设备',
    link: 'https://help.yfanqie.com/1f8d/35e9/9af0',
  },
];

export const SF_DOWNLOAD_INFO = [
  {
    title: '(FX)安装教程 >',
    desc: '适用于FXN1、P1设备',
    link: 'https://help.yfanqie.com/7cb4/3ed5/77f6',
  },
  {
    title: '(WJY)安装教程 >',
    desc: '适用于WJY等ARM64架构',
    link: 'https://help.yfanqie.com/7cb4/3ed5/67eb',
  },
];

export const HELP_LINK = 'https://help.yfanqie.com/c165/2387';
